<shared-form-editor [config]="config"></shared-form-editor>
